import type { Appointment, Service } from '../types';

/** All primary service ids on an appointment, tolerating pre-migration rows. */
export const getAppointmentServiceIds = (app: Appointment): string[] =>
  Array.isArray(app.serviceIds) && app.serviceIds.length > 0
    ? app.serviceIds
    : app.serviceId
      ? [app.serviceId]
      : [];

/**
 * Display name for an appointment's services ("SCW + Health Surveillance").
 * Falls back to the server-enriched serviceName (already a joined list for
 * staff endpoints) and finally the raw id.
 */
export const getAppointmentServiceNames = (
  app: Appointment,
  servicesById: Map<string, Service>
): string => {
  const names = getAppointmentServiceIds(app)
    .map((id) => servicesById.get(id)?.name)
    .filter((name): name is string => Boolean(name));
  if (names.length > 0) return names.join(' + ');
  return app.serviceName || app.serviceId || '';
};
